import { createContext } from "react";

const ShippingDataContext = createContext();

export default ShippingDataContext;
